// extracted by mini-css-extract-plugin
export default {"verifyContainer":"index_verifyContainer__a+0Rk"};